/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Spellcheck_Start_ErrorInputs */

const en_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error starting spell check ${i?.error}`)
};

const fr_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors du demarrage de la verification orthographique ${i?.error}`)
};

const de_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beim Starten der Rechtschreibprüfung ist ein Fehler aufgetreten ${i?.error}`)
};

const it_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante l'avvio del controllo ortografico ${i?.error}`)
};

const ru_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Произошла ошибка при запуске проверки орфографии ${i?.error}`)
};

const es_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se produjo un error al iniciar la corrección ortográfica ${i?.error}`)
};

const zh_cn2_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开始拼写检查时出错 ${i?.error}`)
};

const ja_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スペルチェック ${i?.error} の開始中にエラーが発生しました`)
};

const hi_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वर्तनी जाँच शुरू करने में त्रुटि आई ${i?.error}`)
};

const pt_pt2_spellcheck_start_error = /** @type {(inputs: Spellcheck_Start_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro ao iniciar a verificação ortográfica ${i?.error}`)
};

/**
* | output |
* | --- |
* | "There was an error starting spell check {error}" |
*
* @param {Spellcheck_Start_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_start_error = /** @type {((inputs: Spellcheck_Start_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Start_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_start_error(inputs)
	if (locale === "de") return de_spellcheck_start_error(inputs)
	if (locale === "it") return it_spellcheck_start_error(inputs)
	if (locale === "ru") return ru_spellcheck_start_error(inputs)
	if (locale === "es") return es_spellcheck_start_error(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_start_error(inputs)
	if (locale === "ja") return ja_spellcheck_start_error(inputs)
	if (locale === "hi") return hi_spellcheck_start_error(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_start_error(inputs)
	return en_spellcheck_start_error(inputs)
});